module.exports = __webpack_public_path__ + "img/YELLoop_logo_slogan.59bdf91b.svg";